module.exports = __webpack_public_path__ + "static/media/address-office-icon.29ebaa75.svg";